import React, { useState, useContext } from 'react';

import { useTranslation, withTranslation, Trans } from 'react-i18next'

import { Translation } from 'react-i18next';


let layout = {
    labelCol: { span: 24 },
    wrapperCol: { span: 24 },
  };

  let horiLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 18 },
  };


  const TranslationComp = (props)=>{
    const { t } = useTranslation();
    // return t(name)

    // return(
    //   <p>{t(name)}</p>
    // )
    return(<Translation>
      {
        (t, { i18n }) => <p className="custLabel">{t(props.name)}</p>
      }
    </Translation>)
  }

  const custDate = (text)=>{
    return new Date(text*1000).toLocaleString()
      // return await import('moment');
  }
  
  // const custMoment = ()=>{
  //   return (async () => {
  //     return await moment()
  //   })()
  // }

  export { layout, horiLayout, TranslationComp, custDate }